// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__2240V","navlink":"NavBar_navlink__31tkR","microPic":"NavBar_microPic__10jmN"};